
import { FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../_metronic/helpers'
import { ROUTER_CONSTANTS } from '../../core/constants/common/router-constants';
import { PageLayout } from '@/layout/page-layout'
import { t } from 'i18next'
import * as authHelper from '@modules/auth/core/AuthHelpers'
import AdminHome from '@/projects/platform/home/admin/admin-home';
import HomePage from '@/projects/platform/home/home';
import Preorder from '@/projects/syncflow/preorder/preorder';
import OrderList from './order/order-list'
import OrderDetail from './order/order-detail';
import OrderSetting from './order/order-setting'

import VendorSupplyParameter from '@/projects/syncflow/vendor_supply_parameter/vendor_supply_parameter';

import ProductSupplyParameter from '@/projects/syncflow/product_supply_parameter/product_supply_parameter';
import SupplierOrderDetail from '@/projects/syncflow/vendor_supply_parameter/vendor_supply_detail';
import InvoiceList from './invoice/invoice-list'
import InvoiceRecording from './invoice/invoice-recording'
import PaymentCalender from './invoice/payment-calender'
import InventoryList from './inventory/inventory-list'
import InventoryDetail from './inventory/inventory-detail'

import Balance from './invoice/balance'

import ForecastList from './forecast/forecast-list'
import AdditionalOrder from './additional-order/additional-order'
import SystemParameterList from './parameter/parameter-list'
import WaybillList from './waybill/waybill-list'
import WaybillAdd from './waybill/waybill-add'
import ProductPortfolio from './product-portfolio/product-portfolio'
import ProductRecipe from './product-recipe/product-recipe' 
import SupplierList from './supplier/supplier-list'


const SyncFlowRoutes = () => {

  const auth = authHelper.getAuth();
  if (!auth) {
    window.location.reload()
  }


  const menuItems = authHelper.getMenu();
  const doesHomeExist = (homeName: string) => menuItems?.some((item: any) => item.name === homeName) || null;
  const adminHomeExists = doesHomeExist('AdminHome');

  const getHomeComponent = () => {
    if (adminHomeExists) return <AdminHome />;
    return <HomePage />;
  };



  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route
          path={ROUTER_CONSTANTS.HomePage}
          element={
            <PageLayout path={ROUTER_CONSTANTS.HomePage} title={t('home_page')}>
              {getHomeComponent()}
            </PageLayout>
          }
        />

        <Route path={ROUTER_CONSTANTS.SYNCFLOW.VendorSupplyParameter} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.VendorSupplyParameter} title={t('syncflow:vendor_supply_parameter')}><VendorSupplyParameter /></PageLayout>} />

        <Route path={ROUTER_CONSTANTS.SYNCFLOW.ProductSupplyParameter} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.ProductSupplyParameter} title={t('syncflow:product_supply_parameter')}><ProductSupplyParameter /></PageLayout>} />

        <Route path={ROUTER_CONSTANTS.SYNCFLOW.VendorAdd} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.VendorAdd} title={t('syncflow:vendor_supply_parameter')}><SupplierOrderDetail /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.VendorDetail} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.VendorDetail} title={t('syncflow:vendor_supply_parameter')}><SupplierOrderDetail /></PageLayout>} />

        <Route path={ROUTER_CONSTANTS.SYNCFLOW.Preorder} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.Preorder} title={t('syncflow:ti_daily_orders')}><Preorder /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.OrderList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.OrderList} title={t('syncflow:ti_orders')}><OrderList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.OrderDetail} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.OrderDetail} title={t('syncflow:ti_order_details')}><OrderDetail /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.OrderSetting} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.OrderSetting} title={t('syncflow:ti_order_settings')}><OrderSetting /></PageLayout>} />


        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceList} title={t('syncflow:invoice_list')}><InvoiceList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceRecording} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceRecording} title={t('syncflow:invoice_add')}><InvoiceRecording /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceDetail} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceDetail} title={t('syncflow:invoice_detail')}><InvoiceRecording /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.PaymentCalender} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.PaymentCalender} title={t('syncflow:payment_calender')}><PaymentCalender /></PageLayout>} />

        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InventoryList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InventoryList} title={t('syncflow:inventory_list')}><InventoryList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InventoryDetail} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InventoryDetail} title={t('syncflow:inventory_detail')}><InventoryDetail /></PageLayout>} />


        <Route path={ROUTER_CONSTANTS.SYNCFLOW.Balance} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.Balance} title={t('syncflow:lb_balance')}><Balance /></PageLayout>} />

        <Route path={ROUTER_CONSTANTS.SYNCFLOW.ForecastList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.ForecastList} title={t('syncflow:forecast_accuracy')}><ForecastList /></PageLayout>} />


        <Route path={ROUTER_CONSTANTS.SYNCFLOW.AdditionalOrder} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.AdditionalOrder} title={t('syncflow:additional_order')}><AdditionalOrder /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.AdditionalOrderDetai} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.AdditionalOrderDetai} title={t('syncflow:additional_detail')}><AdditionalOrder /></PageLayout>} />

        <Route path={ROUTER_CONSTANTS.SYNCFLOW.ParameterList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.ParameterList} title={t('syncflow:system_parameters')}><SystemParameterList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.WaybillList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.WaybillList} title={t('syncflow:waybill_list')}><WaybillList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.WaybillAdd} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.WaybillAdd} title={t('syncflow:waybill_add')}><WaybillAdd /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.WaybillDetail} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.WaybillDetail} title={t('syncflow:waybill_detail')}><WaybillAdd /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.ProductPortfolio} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.ProductPortfolio} title={t('syncflow:product_portfolio')}><ProductPortfolio /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.ProductRecipe} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.ProductRecipe} title={t('syncflow:product_recipe')}><ProductRecipe /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.SupplierList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.SupplierList} title={t('syncflow:supplier_list')}><SupplierList /></PageLayout>} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default SyncFlowRoutes